import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './core/auth-interceptor';
import { CoreModule } from './modules/core.module';
import { QuillModule } from 'ngx-quill';
import { environment } from 'src/environments/environment';
import { GoogleMapsModule } from '@angular/google-maps';
import { AgmCoreModule } from '@agm/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as Sentry from "@sentry/angular-ivy";
import { Router } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ViewAllCsrComponent } from './view-all-csr/view-all-csr.component';
import { FooterComponent } from './components/template/footer/footer.component';
import { LoaderComponent } from './components/template/loader/loader.component';
import { GooglemapsComponent } from './components/googlemaps/googlemaps.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { keyValueTypeComponent } from './components/formlyFormcontrols/wrappers/key-value';
import { HeadingComponent } from './components/formlyFormcontrols/wrappers/heading';
import { LoginAggreementComponent } from './components/login-aggreement/login-aggreement.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    ViewAllCsrComponent,
    FooterComponent,
    LoaderComponent,
    GooglemapsComponent,
    keyValueTypeComponent,
    HeadingComponent,
    LoginAggreementComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    FormsModule,
    QuillModule.forRoot(),
    FormlyModule.forRoot({}),
    HttpClientModule,
    CoreModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatStepperModule,
    DragDropModule,
    MatTooltipModule,
    MatCheckboxModule,
    HttpClientJsonpModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapKey,
      libraries: ['places']
    }),
    GoogleMapsModule,
    GooglePlaceModule,
    TranslateModule.forRoot({     
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
    }),
  ],
  providers: [
    AuthInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        //showDialog: true,// Sentry feedback popup
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
